import { ModelBase } from 'store/model-base';

export class CmsRoleBasedCustomer extends ModelBase {
    public static storeName: string = 'cmsRoleBasedCustomer';

    public header: string;
    public action: string;
    public backgroundImage: CmsMediaImage;
    public endNote: string;
    public endNoteLink: string;
    public endNoteLinkText: string;
}
